<template>
  <div v-if="mostrarDebugCounter">
    <v-btn
      color="primary"
      dark
      fab
      small
      fixed
      bottom
      right
      class="counter-debug-btn"
      @click="dialogoContador = true"
    >
      <v-icon>mdi-counter</v-icon>
    </v-btn>
    <v-dialog
      v-model="dialogoContador"
      max-width="320"
      hide-overlay
      content-class="counter-debug-dialog"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center py-3">
          <span class="text-subtitle-1 font-weight-medium">Contador store</span>
          <v-btn icon small @click="dialogoContador = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-3">
          <div class="mb-3">
            <div class="text-caption">Sesion portal</div>
            <div class="counter-debug-timer">
              {{ formatoCuentaRegresiva(sessionRemainingMs) }}
            </div>
            <div class="text-caption mt-1">
              Usuario: {{ isUserIdle ? "inactivo" : "activo" }}
            </div>
          </div>
          <div v-if="directSessionRemainingMs > 0" class="mb-3">
            <div class="text-caption">Sesion pago directo</div>
            <div class="counter-debug-timer">
              {{ formatoCuentaRegresiva(directSessionRemainingMs) }}
            </div>
          </div>
          <div class="text-caption mb-2">
            Estado: {{ setCounter ? "cargado" : "pendiente" }}
          </div>
          <div v-if="counterEntries.length" class="counter-debug-list">
            <div
              v-for="[key, value] in counterEntries"
              :key="key"
              class="d-flex align-center justify-space-between py-1"
            >
              <span class="counter-debug-key">{{ key }}</span>
              <v-chip small color="primary" text-color="white">
                {{ value }}
              </v-chip>
            </div>
          </div>
          <div v-else class="text-caption">
            No hay contadores disponibles en `userCounter`.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DebugCounter",
  data() {
    return {
      dialogoContador: false
    };
  },
  computed: {
    ...mapState([
      "userCounter",
      "setCounter",
      "sessionRemainingMs",
      "directSessionRemainingMs",
      "isUserIdle"
    ]),
    mostrarDebugCounter() {
      return process.env.VUE_APP_MODE === "demo";
    },
    counterEntries() {
      return Object.entries(this.userCounter || {});
    }
  },
  methods: {
    formatoCuentaRegresiva(remainingMs) {
      const totalSeconds = Math.max(Math.ceil(remainingMs / 1000), 0);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      return [hours, minutes, seconds]
        .map((value) => String(value).padStart(2, "0"))
        .join(":");
    }
  }
};
</script>

<style lang="css">
.counter-debug-btn {
  z-index: 1001 !important;
  bottom: 88px !important;
}
.counter-debug-dialog {
  position: absolute;
  right: 24px;
  bottom: 140px;
  margin: 0 !important;
  overflow: visible;
}
.counter-debug-list {
  max-height: 240px;
  overflow-y: auto;
}
.counter-debug-timer {
  font-size: 1.5rem;
  line-height: 1.8rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.06em;
}
.counter-debug-key {
  max-width: 190px;
  font-size: 0.85rem;
  line-height: 1.1rem;
  word-break: break-word;
}
</style>
